import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import SolicitacaoService from "../../services/resource/solicitacaoService";
import { departamentoInfo, processoInfo } from "../../utils/solicitacoes/processoRegistry";

const service = new SolicitacaoService();

// Junta os processos/departamentos reais do backend com o rótulo/ícone/formulário conhecidos
// localmente em processoRegistry.js (que já é a fonte de verdade para "como desenhar" cada processo).
export function useProcessos() {
    const [processos, setProcessos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        service.listarProcessos()
            .then(res => {
                const enriquecidos = res.data.map(p => ({
                    ...p,
                    ...processoInfo(p.tipoProcesso),
                }));
                setProcessos(enriquecidos);
            })
            .catch(error => {
                console.error("Erro ao listar processos", error);
                toast.error("Erro ao carregar os processos disponíveis");
            })
            .finally(() => setLoading(false));
    }, []);

    const departamentos = Array.from(new Set(processos.map(p => p.departamento)))
        .map(departamento => ({
            departamento,
            processos: processos.filter(p => p.departamento === departamento),
        }))
        .sort((a, b) => departamentoInfo(a.departamento).label.localeCompare(departamentoInfo(b.departamento).label));

    return { processos, departamentos, loading };
}
